export enum AssistantMode {
    RAG = 'rag',
    SQL = 'sql',
}

export interface QaSource {
    service_line_id: number;
    salesforce_line_item_id: string | null;
    service_name: string;
    quote_date: string | null;
}

export interface AskAutoResponse {
    question: string;
    answer: string;
    answer_type: 'sql' | 'rag';
    sql?: string | null;
    columns?: string[];
    rows?: unknown[][];
    row_count?: number;
    truncated?: boolean;
    sources?: QaSource[];
    retrieved_count?: number;
    prompt_version: string;
    provider: string;
    model: string;
}

export interface SqlResult {
    columns: string[];
    rows: unknown[][];
    sql: string;
    rowCount: number;
    truncated: boolean;
}

export interface AssistantAnswerMeta {
    retrievedCount?: number;
    promptVersion: string;
    provider: string;
    model: string;
}

export interface AssistantAnswer {
    id: string;
    question: string;
    mode: AssistantMode;
    answer: string;
    timestamp: string;
    sources?: QaSource[];
    meta?: AssistantAnswerMeta;
    sqlResult?: SqlResult;
}
